import useAdminAccess from "hooks/useAdminAccess";
import { Link, LinkProps, useResolvedPath } from "react-router-dom";
import { requiredAdminPermissionsForPath } from "services/adminAccess";

/** Use the route guard's permission mapping for in-dashboard links too. */
export default function AdminLink(props: LinkProps) {
  const { canAny } = useAdminAccess();
  const { pathname } = useResolvedPath(props.to);
  if (!canAny(requiredAdminPermissionsForPath(pathname) ?? [])) return null;
  return <Link {...props} />;
}
